import { render, staticRenderFns } from "./gTypes.vue?vue&type=template&id=02b51e7a&scoped=true&"
import script from "./gTypes.vue?vue&type=script&lang=js&"
export * from "./gTypes.vue?vue&type=script&lang=js&"
import style0 from "./gTypes.vue?vue&type=style&index=0&id=02b51e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b51e7a",
  null
  
)

export default component.exports